import React, { useState , useContext } from 'react'
import { AppContext } from '../context/AppContext';
import { Offcanvas, Carousel } from 'react-bootstrap';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { ImLocation } from 'react-icons/im';
import { MdArrowBackIos, MdArrowForwardIos, MdOutlineWatchLater, MdSearch, MdWatchLater } from 'react-icons/md';


const LocationSlideThree = () => {

    

  const {retrive} = useContext(AppContext);

  const {slideIndex} = useContext(AppContext);

  const [ EventOE, setEventOE ] = useState('0px');

  const [ indexSlideValue , setIndexSlideValue ] = slideIndex;

  const [ retreivealMarker ] = retrive;
 
  const [ openDays, setopenDays ] = useState([
    {title:'الأحد',open:'يفتح 8 صباح',close:'يغلق 11:30 مساء'},
    {title:'الإثنين',open:'يفتح 8 صباح',close:'يغلق 11:30 مساء'},
    {title:'الثلاثاء',open:'يفتح 8 صباح',close:'يغلق 11:30 مساء'},
    {title:'الأربعاء',open:'يفتح 8 صباح',close:'يغلق 11:30 مساء'},
    {title:'الخميس',open:'يفتح 8 صباح',close:'يغلق 11:30 مساء'},
    {title:'الجمعة',open:'يفتح 2 ظهرا',close:'يغلق 11:30 مساء'},
    {title:'السبت',open:'يفتح 8 صباح',close:'يغلق 11:30 مساء'},
]);

 

  return (
    <div className=" slide_main_div">

    <div className='container-sm' >
      
   

        <div className="top_area_slide_two d-flex-c f-sv f-wrap">
        <button className="btn_status_location"> 
        {retreivealMarker.category == "event" && "فعالية"}
                {retreivealMarker.category == "public_place" && "مكان عام"}
                {retreivealMarker.category == "tourist" && "منتجع سياحي"}
                {retreivealMarker.category == "coffee" && "كوفيه"}
                {retreivealMarker.category == "restaurant" && "مطعم"}
         </button>
        <h1 className='location_slidetwo_headline' >  {retreivealMarker.name} </h1>
        </div>

        <Carousel controls={false} pause={false} className="bg-white mt-2" style={{width:'100%',height:'240px'}}>
                        {
                            retreivealMarker.photos &&  retreivealMarker.photos.map(function(item,i){
                                return <Carousel.Item key={i} interval={3000} className="p-0 text-end hand" style={{width:'100%',height:'240px'}}>
                                    <img src={item} className="" style={{objectFit:'cover',objectPosition:'center',width:'100%',height:'240px'}} />
                                </Carousel.Item>
                            })
                        }
                    </Carousel>

        <p className="main_para mt-2">  {retreivealMarker.description}</p>

        <div className='col-12 mt-2 r-direction'>
                        <div className='w-100 d-flex justify-content-between border-bottom p-2'>
                            <div className='d-flex align-items-center'>
                                <MdOutlineWatchLater size={24} className='text-primary'/>
                                <div className='fw-bold text-success ms-2 me-1'>مفتوح</div>
                                <div className='text-muted'>الإغلاق الساعة 11:30 مساء</div>
                            </div>
                            <div className='hand' onClick={()=> EventOE=="0px"?setEventOE('224px'):setEventOE('0px')}>
                                {
                                    EventOE=="0px"?<BsChevronDown/>:<BsChevronUp/>
                                }
                            </div>
                        </div>
                        <div className='overflow-hidden events-opens-trans' style={{height:EventOE}}>
                            <ul className='fw-bold text-muted' style={{listStyle:'square'}}>
                                {
                                    openDays.map(function(item,i){
                                        return <li className='d-flex' style={{marginTop:'5px'}}>
                                            <div className='text-dark ms-3'>{item['title']}</div>
                                            <div className='ms-3 text-muted'>{item['open']}</div>
                                            <div className='text-muted'>{item['close']}</div>
                                        </li>;
                                    })
                                }
                            </ul>
                        </div>
                    </div>

        <div className="place_sections mt-4 text-right">
        <h1 className='location_slidetwo_headline' >  اقسام المكان </h1>
        <div className="mt-1"></div>
        
        {retreivealMarker.sections  && retreivealMarker.sections.map((item) => (
            <div className="single_place_section_div m-2">

        <div className="section_img_div">
            <img src={item.image} alt="" />
            </div>

            <div className="section_info_div">
            <h1 className='mt-1' > {item.name} </h1>
            <div className="mt-1-small"></div>
            <p className='' >    {item.desc}  </p>
            </div>

        
        </div>
        )) }


        

   

        </div>


{/* 
        <h1 className='mt-3 text-right location_slidetwo_headline' >  الصور</h1>

<div className="grid_photos_area mt-2">

        {retreivealMarker.photos && retreivealMarker.photos.map((item) => (
            <div className="single_card_div_slidetwo">
    <img  src={item} alt="" />
  
</div>
        )) }



</div> */}

<div className="f-sv d-flex-c sliding_btns mt-1 mb-3">
              <button className="btn_category bg_red " onClick={() => setIndexSlideValue(indexSlideValue - 1) } > السابق </button>
                <button className="btn_category bg_green" onClick={() => setIndexSlideValue( indexSlideValue + 1) } > التالي </button>
              </div>

    </div>


      


    </div>
  )
}

export default LocationSlideThree